import type { IconSvgObject } from './types';

const CalendarOffIcon: IconSvgObject = [
  ["path", { d: "M16.5 2V6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 4H19C20.1046 4 21 4.89543 21 6V16M4.17675 4.17675C3.48283 4.49057 3 5.1889 3 6V20C3 21.1046 3.89543 22 5 22H19C19.8111 22 20.5094 21.5172 20.8232 20.8232", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 10H10M21 10H15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default CalendarOffIcon;
